module.exports = __webpack_public_path__ + "img/001-artist.ed963012.png";